import React, { useState } from 'react';
import { Button } from '../../ui/button';
import { FileDown, Loader2 } from 'lucide-react';
import api from '../../../utils/api';
import {
  assertBlobKind,
  filenameFromDisposition,
  parseBlobError,
} from '../../../utils/blobDownload';
import { useToast } from '../../../hooks/use-toast';

export default function AttendanceExportBar({
  parentMode,
  studentId,
  month,
  monthYear,
  onPdfReady,
}) {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);

  const downloadPdf = async () => {
    const base = parentMode
      ? '/portal/parent/attendance/month/pdf'
      : '/portal/student/attendance/month/pdf';
    const params = {
      month,
      month_year: monthYear,
      ...(parentMode && studentId ? { student_id: studentId } : {}),
    };
    setLoading(true);
    try {
      const res = await api.get(base, { params, responseType: 'blob' });
      const blob = res.data;
      const msg = await parseBlobError(blob);
      if (msg) {
        throw new Error(msg);
      }
      await assertBlobKind(blob, 'pdf');
      const fallback = `attendance-${monthYear}-${month}.pdf`;
      const filename = filenameFromDisposition(
        res.headers['content-disposition'],
        fallback,
      );
      const monthLabel = new Date(monthYear, month - 1, 1).toLocaleString('en-US', {
        month: 'long',
        year: 'numeric',
      });
      onPdfReady?.(blob, filename, `Attendance — ${monthLabel}`);
    } catch (e) {
      toast({
        title: 'Export failed',
        description: e?.message || 'Could not load PDF',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      <Button type="button" variant="outline" size="sm" disabled={loading} onClick={downloadPdf}>
        {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <FileDown className="h-4 w-4 mr-2" />}
        Export month PDF
      </Button>
    </div>
  );
}
